import React from 'react';
function SectionCard({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
    borderColor: '#ede9e0'
  }} data-id="element-629">
      <h2 className="text-xl md:text-2xl font-bold uppercase mb-5 pb-3 border-b" style={{
      fontFamily: 'Oswald, sans-serif',
      color: '#1e3d2f',
      borderColor: '#ede9e0'
    }} data-id="element-630">
        {title}
      </h2>
      <div className="space-y-4 text-base text-gray-800 leading-relaxed" style={{
      fontFamily: 'Inter, sans-serif'
    }} data-id="element-631">
        {children}
      </div>
    </div>;
}
export function ConstitutionArticles() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-632">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-10" data-id="element-633">
        <div className="space-y-8" data-id="element-634">
          <section id="preamble" data-id="element-635">
            <SectionCard title="Preamble" data-id="element-636">
              <p data-id="element-637">
                We, the members of the Fenton Lakes Sportsman's Club, in order
                to promote the shooting sports, conservation of natural
                resources, and fellowship among sportsmen, do ordain and
                establish this Constitution for the governance of our
                organization.
              </p>
              <p data-id="element-638">
                The club shall be organized and operated exclusively for the
                purposes of promoting and supporting recreational shooting
                sports, wildlife conservation, hunter education, and community
                fellowship in the Fenton, Michigan area.
              </p>
            </SectionCard>
          </section>

          <section id="article-i" data-id="element-639">
            <SectionCard title="Article I — Name" data-id="element-640">
              <p data-id="element-641">
                <strong data-id="element-642">Section 1.</strong> The name of this organization shall
                be the <strong data-id="element-643">Fenton Lakes Sportsman's Club</strong>,
                hereinafter referred to as "the Club."
              </p>
              <p data-id="element-644">
                <strong data-id="element-645">Section 2.</strong> The Club shall be located at 1140
                Butcher Road, Fenton, Michigan 48430.
              </p>
            </SectionCard>
          </section>

          <section id="article-ii" data-id="element-646">
            <SectionCard title="Article II — Object" data-id="element-647">
              <p data-id="element-648">
                <strong data-id="element-649">Section 1.</strong> The object of this Club shall be:
              </p>
              <ol className="list-decimal ml-6 space-y-2" data-id="element-650">
                <li data-id="element-651">
                  To promote and encourage organized shooting sports among its
                  members and the community.
                </li>
                <li data-id="element-652">To promote the safe handling and use of firearms.</li>
                <li data-id="element-653">
                  To promote the conservation of natural resources and wildlife.
                </li>
                <li data-id="element-654">To promote good fellowship among sportsmen.</li>
                <li data-id="element-655">
                  To cooperate with local, state, and federal agencies in the
                  conservation and restoration of natural resources.
                </li>
                <li data-id="element-656">
                  To provide and maintain suitable facilities for the use of its
                  members in the pursuit of the shooting sports and related
                  activities.
                </li>
                <li data-id="element-657">
                  To promote and support hunter education and firearms safety
                  training.
                </li>
              </ol>
            </SectionCard>
          </section>

          <section id="article-iii" data-id="element-658">
            <SectionCard title="Article III — Membership" data-id="element-659">
              <p data-id="element-660">
                <strong data-id="element-661">Section 1.</strong> Any person of good character who is
                interested in the objectives of this Club may apply for
                membership. Applications for membership shall be submitted in
                writing on forms provided by the Club.
              </p>
              <p data-id="element-662">
                <strong data-id="element-663">Section 2.</strong> All applications for membership
                shall be reviewed by the Membership Committee and approved by
                the Board of Directors. The Board of Directors shall have the
                final authority on all membership applications.
              </p>
              <p data-id="element-664">
                <strong data-id="element-665">Section 3.</strong> Classes of membership shall include:
              </p>
              <ol className="list-[lower-alpha] ml-6 space-y-2" data-id="element-666">
                <li data-id="element-667">
                  <strong data-id="element-668">Regular Member:</strong> Any person 18 years of age or
                  older who has been accepted for membership and has paid the
                  required dues and fees.
                </li>
                <li data-id="element-669">
                  <strong data-id="element-670">Family Member:</strong> The spouse and dependent
                  children (under 18) of a Regular Member.
                </li>
                <li data-id="element-671">
                  <strong data-id="element-672">Junior Member:</strong> Any person under 18 years of
                  age who has been accepted for membership with parental
                  consent.
                </li>
                <li data-id="element-673">
                  <strong data-id="element-674">Life Member:</strong> Any Regular Member who has been
                  granted life membership by the Board of Directors in
                  recognition of outstanding service to the Club.
                </li>
                <li data-id="element-675">
                  <strong data-id="element-676">Honorary Member:</strong> Any person who has been
                  granted honorary membership by the Board of Directors.
                </li>
              </ol>
              <p data-id="element-677">
                <strong data-id="element-678">Section 4.</strong> Any member may be suspended or
                expelled for cause by a two-thirds vote of the Board of
                Directors, after due notice and hearing. Cause for suspension or
                expulsion shall include, but not be limited to, violation of
                Club rules, conduct unbecoming a member, or failure to pay dues.
              </p>
            </SectionCard>
          </section>

          <section id="article-iv" data-id="element-679">
            <SectionCard title="Article IV — Officers" data-id="element-680">
              <p data-id="element-681">
                <strong data-id="element-682">Section 1.</strong> The officers of this Club shall be:
                President, Vice President of Operations, Vice President of
                Marketing, Vice President of Finance, and Secretary.
              </p>
              <p data-id="element-683">
                <strong data-id="element-684">Section 2.</strong> Officers shall be elected by ballot
                at the annual meeting and shall serve for a term of two (2)
                years or until their successors are elected and installed.
              </p>
              <p data-id="element-685">
                <strong data-id="element-686">Section 3.</strong> No member shall hold more than one
                office at a time.
              </p>
              <p data-id="element-687">
                <strong data-id="element-688">Section 4.</strong> Any vacancy occurring in any office
                shall be filled by appointment by the Board of Directors for the
                unexpired term.
              </p>
              <p data-id="element-689">
                <strong data-id="element-690">Section 5.</strong> Any officer may be removed from
                office for cause by a two-thirds vote of the Board of Directors,
                after due notice and hearing.
              </p>
            </SectionCard>
          </section>

          <section id="article-v" data-id="element-691">
            <SectionCard title="Article V — Duties of Officers" data-id="element-692">
              <p data-id="element-693">
                <strong data-id="element-694">Section 1. President.</strong> The President shall
                preside at all meetings of the Club and the Board of Directors.
                The President shall be the chief executive officer of the Club
                and shall have general supervision of the affairs of the Club.
                The President shall appoint all committees not otherwise
                provided for.
              </p>
              <p data-id="element-695">
                <strong data-id="element-696">Section 2. Vice President of Operations.</strong> The
                Vice President of Operations shall assist the President and
                shall preside in the absence of the President. The VP of
                Operations shall oversee the day-to-day operations of the Club
                facilities and ranges.
              </p>
              <p data-id="element-697">
                <strong data-id="element-698">Section 3. Vice President of Marketing.</strong> The
                Vice President of Marketing shall be responsible for promoting
                the Club's activities, events, and membership. The VP of
                Marketing shall oversee communications, the newsletter, and
                public relations.
              </p>
              <p data-id="element-699">
                <strong data-id="element-700">Section 4. Vice President of Finance.</strong> The Vice
                President of Finance shall have charge of all funds of the Club.
                The VP of Finance shall keep accurate records of all receipts
                and disbursements, and shall make a financial report at each
                regular meeting and at the annual meeting.
              </p>
              <p data-id="element-701">
                <strong data-id="element-702">Section 5. Secretary.</strong> The Secretary shall keep
                accurate minutes of all meetings of the Club and the Board of
                Directors. The Secretary shall handle all correspondence and
                maintain the official records of the Club.
              </p>
            </SectionCard>
          </section>

          <section id="article-vi" data-id="element-703">
            <SectionCard title="Article VI — Meetings" data-id="element-704">
              <p data-id="element-705">
                <strong data-id="element-706">Section 1.</strong> Regular meetings of the Club shall
                be held monthly at a time and place designated by the Board of
                Directors.
              </p>
              <p data-id="element-707">
                <strong data-id="element-708">Section 2.</strong> The annual meeting shall be held in
                the month designated by the Board of Directors for the purpose
                of electing officers, receiving annual reports, and transacting
                other business.
              </p>
              <p data-id="element-709">
                <strong data-id="element-710">Section 3.</strong> Special meetings may be called by
                the President or by a majority of the Board of Directors.
                Written notice of special meetings shall be given to all members
                at least seven (7) days prior to the meeting.
              </p>
              <p data-id="element-711">
                <strong data-id="element-712">Section 4.</strong> A quorum for the transaction of
                business at any meeting shall consist of the members present,
                provided that at least twenty-five (25) members are in
                attendance.
              </p>
            </SectionCard>
          </section>

          <section id="article-vii" data-id="element-713">
            <SectionCard title="Article VII — Board of Directors" data-id="element-714">
              <p data-id="element-715">
                <strong data-id="element-716">Section 1.</strong> The Board of Directors shall consist
                of the elected officers and such additional directors as
                provided for in the By-Laws.
              </p>
              <p data-id="element-717">
                <strong data-id="element-718">Section 2.</strong> The Board of Directors shall have
                general supervision of the affairs of the Club between regular
                meetings, shall authorize all expenditures, and shall have the
                authority to act on all matters not specifically reserved to the
                membership.
              </p>
              <p data-id="element-719">
                <strong data-id="element-720">Section 3.</strong> The Board of Directors shall meet at
                least once per month. A majority of the Board shall constitute a
                quorum.
              </p>
            </SectionCard>
          </section>

          <section id="article-viii" data-id="element-721">
            <SectionCard title="Article VIII — Committees" data-id="element-722">
              <p data-id="element-723">
                <strong data-id="element-724">Section 1.</strong> Standing committees shall include,
                but not be limited to: Membership, Range, Grounds, House,
                Finance, and Activities.
              </p>
              <p data-id="element-725">
                <strong data-id="element-726">Section 2.</strong> The President shall appoint the
                chairperson of each standing committee, subject to approval by
                the Board of Directors.
              </p>
              <p data-id="element-727">
                <strong data-id="element-728">Section 3.</strong> Special committees may be appointed
                by the President as needed to carry out the work of the Club.
              </p>
            </SectionCard>
          </section>

          <section id="article-ix" data-id="element-729">
            <SectionCard title="Article IX — Dues and Fees" data-id="element-730">
              <p data-id="element-731">
                <strong data-id="element-732">Section 1.</strong> Annual dues and fees shall be
                established by the Board of Directors and approved by the
                membership at the annual meeting.
              </p>
              <p data-id="element-733">
                <strong data-id="element-734">Section 2.</strong> Dues shall be payable on or before
                the date established by the Board of Directors. Members whose
                dues are not paid within thirty (30) days of the due date shall
                be considered delinquent and may be suspended.
              </p>
              <p data-id="element-735">
                <strong data-id="element-736">Section 3.</strong> New members shall pay an initiation
                fee in addition to annual dues, as established by the Board of
                Directors.
              </p>
            </SectionCard>
          </section>

          <section id="article-x" data-id="element-737">
            <SectionCard title="Article X — Amendments" data-id="element-738">
              <p data-id="element-739">
                <strong data-id="element-740">Section 1.</strong> This Constitution may be amended at
                any regular or special meeting of the Club by a two-thirds vote
                of the members present, provided that the proposed amendment has
                been submitted in writing to the membership at least thirty (30)
                days prior to the meeting at which it is to be voted upon.
              </p>
              <p data-id="element-741">
                <strong data-id="element-742">Section 2.</strong> Proposed amendments may be submitted
                by any member in good standing or by the Board of Directors.
              </p>
            </SectionCard>
          </section>

          <section id="article-xi" data-id="element-743">
            <SectionCard title="Article XI — Parliamentary Authority" data-id="element-744">
              <p data-id="element-745">
                <strong data-id="element-746">Section 1.</strong> Robert's Rules of Order, Newly
                Revised, shall govern the proceedings of this Club in all cases
                to which they are applicable and in which they are not
                inconsistent with this Constitution and By-Laws.
              </p>
            </SectionCard>
          </section>
        </div>
      </div>
    </div>;
}